import { GlobalState } from 'store/types';

export const chartAnalyticsDataSelector = (chartName: string) => (state: GlobalState) => {
  return state.pages.posHome.analytics.data.charts?.find((chart) => chart.name === chartName);
};

export const metricAnalyticsDataSelector = (boxName: string) => (state: GlobalState) => {
  return state.pages.posHome.analytics.data.metrics?.find((chart) => chart.name === boxName);
};
